import { createStyles } from '@mantine/core';

var useStyles = createStyles((theme) => {
    return {
        root: {},
        inner: {},
        content: {
            borderRadius: 16,
        },
        header: {
            borderBottom: `1px solid ${theme.colors.neutral[1]}`,
            marginRight: 0,
            marginBottom: 0,
            padding: '12px',
        },
        overlay: {},
        title: {
            fontSize: 16,
            fontWeight: 700,
            lineHeight: 1.5,
        },
        body: {},
        close: {
            cursor: 'pointer',
            width: 'unset',
            height: 'unset',
            svg: {
                width: '24px !important',
                height: '24px !important',
            },
        },
    };
});

export { useStyles as u };
